var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LandingSections } from '@features/landing/constants';
import { HeaderNavItem } from './header-nav-item.component';
export var HeaderNav = function () {
    return (_jsx("div", __assign({ className: "flex w-full flex-1 justify-center" }, { children: _jsxs("div", __assign({ className: "flex flex-row items-center gap-[30px]" }, { children: [_jsx(HeaderNavItem, { navOptions: __assign({}, LandingSections.aboutUs) }), _jsx(HeaderNavItem, { navOptions: __assign({}, LandingSections.subscription) }), _jsx(HeaderNavItem, { navOptions: __assign({}, LandingSections.contacts) }), _jsx(HeaderNavItem, { navOptions: __assign({}, LandingSections.designing) })] })) })));
};
